export function HeadingTwo({ children }: { children: React.ReactNode }) {
  return (
    <h2 className="text-xl font-semibold text-default mb-2">{children}</h2>
  );
}
